import React from "react";
import * as XLSX from "xlsx";

const ExportExcelButton = ({ formArray, setFormArray, currentFormData, costItems, fileName }) => {
  const handleExportToExcel = () => {
    if (!currentFormData || Object.values(currentFormData).every((val) => val === "")) {
      console.error("Form data is empty or invalid.");
      return;
    }

    try {
      const workbook = XLSX.utils.book_new();
      const dataRows = [];
      
      // STAFF DETAILS SECTION
      dataRows.push(['STAFF DETAILS:']);
      const staffHeaders = [
        'Requisition ID', 'Staff Name', 'Staff Level', 'Supervisor Name', 'Requisition Date'
      ];
      dataRows.push(staffHeaders);
      
      const staffData = [
        currentFormData.requisitionID || 'Pending',
        currentFormData.staffName || '',
        currentFormData.staffLevel || '',
        currentFormData.supervisorName || '',
        currentFormData.requisitionDate || ''
      ];
      dataRows.push(staffData);
      
      // Add empty rows for separation
      dataRows.push([]);
      dataRows.push([]);
      
      // ACTIVITY DETAILS SECTION
      dataRows.push(['ACTIVITY DETAILS:']);
      const activityHeaders = [
        'Activity Name', 'Activity Purpose', 'From Date', 'To Date', 
        'Target Client', 'Expected Impact', 'Country', 'Hub Office'
      ];
      dataRows.push(activityHeaders);
      
      const activityData = [
        currentFormData.activityName || '',
        currentFormData.activityPurpose || '',
        currentFormData.from || '',
        currentFormData.to || '',
        currentFormData.targetClient || '',
        currentFormData.expectedImpact || '',
        currentFormData.country || '',
        currentFormData.hubOffice || ''
      ];
      dataRows.push(activityData);
      
      // Add empty rows for separation
      dataRows.push([]);
      dataRows.push([]);

      // DISTRICTS & AREA PROGRAMS SECTION
      dataRows.push(['DISTRICTS & AREA PROGRAMS / EPAs:']);
      dataRows.push([]);
      
      if (currentFormData.districtAndAreaProgramPairs && currentFormData.districtAndAreaProgramPairs.length > 0) {
        // District Table Headers
        const districtHeaders = ['No.', 'District', 'Area Program / EPA'];
        dataRows.push(districtHeaders);
        
        // District Table Data
        currentFormData.districtAndAreaProgramPairs.forEach((pair, index) => {
          const district = pair.district || 'No district';
          const areaProgram = pair.areaProgram || 'No area program';
          dataRows.push([index + 1, district, areaProgram]);
        });
      } else {
        dataRows.push(['No district/area program data']);
      }

      // Add empty rows for separation
      dataRows.push([]);
      dataRows.push([]);

      
      // PROJECT & ADVANCE DETAILS SECTION
      dataRows.push(['PROJECT & ADVANCE DETAILS:']);
      const projectHeaders = [
        'Project Code', 'Project Name', 'Budget Line Code', 'Pay Mode', 
        'Bank Name', 'Branch', 'Account Number', 'Phone Number'
      ];
      dataRows.push(projectHeaders);
      
      const projectData = [
        currentFormData.projectCode || '',
        currentFormData.projectName || '',
        currentFormData.budgetLineCode || '',
        currentFormData.payMode || '',
        currentFormData.bankName || '',
        currentFormData.branch || '',
        currentFormData.accountNumber || '',
        currentFormData.phoneNumber || ''
      ];
      dataRows.push(projectData);
      
      // Add empty rows for separation
      dataRows.push([]);
      dataRows.push([]);

           
      // COST DRIVERS TABLE SECTION
      dataRows.push(['COST DRIVERS:']);
      dataRows.push([]);
      
      if (costItems && costItems.length > 0) {
        // Cost Drivers Table Headers (matching your frontend)
        const costDriverHeaders = [
          'No.', 
          'Cost Driver', 
          'Justification', 
          'Quantity', 
          'Unit Price (MK)', 
          'Total (MK)', 
          'Support Documents'
        ];
        dataRows.push(costDriverHeaders);
        
        // Cost Drivers Table Data - Keep as pure numbers for calculations
        costItems.forEach((driver, index) => {
          const driverName = driver.costDriver || driver.customCostDriver || 'Unnamed Driver';
          const quantity = driver.quantity || '0';
          const unitPrice = driver.unitPrice || '0';
          const total = driver.total || '0';
          const justification = driver.justification || '';
          const supportDocuments = driver.supportDocuments || '';
          
          const costDriverRow = [
            index + 1,
            driverName,
            justification,
            Number(quantity),
            Number(unitPrice),  // Pure number for calculations
            Number(total),      // Pure number for calculations
            supportDocuments
          ];
          dataRows.push(costDriverRow);
        });
        
        // Add Total Row
        dataRows.push([]);
        const overallTotal = costItems.reduce((sum, driver) => sum + (Number(driver.total) || 0), 0);
        const totalRow = [
          '', '', '', '',
          'Overall Total:',
          overallTotal, // Pure number for calculation
          ''
        ];
        dataRows.push(totalRow);
      } else {
        dataRows.push(['No cost drivers data']);
      }
      
      // Create worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(dataRows);
      
      // Set column widths for better readability
      worksheet['!cols'] = [
        // Staff Details columns
        { wch: 20 }, { wch: 25 }, { wch: 15 }, { wch: 25 }, { wch: 15 },
        
        // Activity Details columns  
        { wch: 30 }, { wch: 40 }, { wch: 12 }, { wch: 12 }, 
        { wch: 30 }, { wch: 30 }, { wch: 15 }, { wch: 20 },
        
        // Project & Advance Details columns
        { wch: 15 }, { wch: 30 }, { wch: 15 }, { wch: 12 }, 
        { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 15 },
        
        // Cost Drivers table columns
        { wch: 5 },   // No.
        { wch: 25 },  // Cost Driver
        { wch: 40 },  // Justification
        { wch: 10 },  // Quantity
        { wch: 15 },  // Unit Price
        { wch: 15 },  // Total
        { wch: 30 }   // Support Documents
      ];
      
      XLSX.utils.book_append_sheet(workbook, worksheet, "Requisition Data");
      XLSX.writeFile(workbook, fileName || "requisition_data.xlsx");
      
    } catch (error) {
      console.error("Error exporting to Excel:", error);
    }
  };

  return (
    <button
      onClick={handleExportToExcel}
      className="the-export-excel-button"
    >
      Export to Excel
    </button>
  );
};

export default ExportExcelButton;